var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectedFileCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7139 0.665955H5.48888C2.66388 0.665955 0.763878 2.64929 0.763878 5.59929V12.4085C0.763878 15.3501 2.66388 17.3326 5.48888 17.3326H12.7139C15.5389 17.3326 17.4305 15.3501 17.4305 12.4085V5.59929C17.4305 2.64929 15.5389 0.665955 12.7139 0.665955V0.665955Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6056 10.4748C11.889 10.7581 11.889 11.2164 11.6056 11.4989C11.464 11.6406 11.2806 11.7164 11.089 11.7164C10.9056 11.7164 10.7223 11.6498 10.5806 11.4989L9.09729 10.0248L7.61396 11.4989C7.47229 11.6406 7.28896 11.7164 7.09729 11.7164C6.91396 11.7164 6.72229 11.6406 6.58063 11.4989C6.29729 11.2164 6.29729 10.7581 6.58063 10.4664L8.06396 8.99145L6.58063 7.50728C6.29729 7.22478 6.29729 6.75812 6.58063 6.47478C6.86396 6.19062 7.32229 6.19062 7.61396 6.47478L9.09729 7.95728L10.5723 6.47478C10.864 6.19062 11.3223 6.19062 11.6056 6.47478C11.889 6.75812 11.889 7.22478 11.6056 7.50728L10.1223 8.99145L11.6056 10.4748Z",
    fill: "#FF5630"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedFileCloseIcon);
export default __webpack_public_path__ + "static/media/selectedFileCloseIcon.70c34e10.svg";
export { ForwardRef as ReactComponent };